// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1y1v6","comment":"styles_comment__3QCyg"};